"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL = exports.LOAD_CONFIG = void 0;
const constants_1 = require("../../../core/script/constants");
exports.LOAD_CONFIG = { order: constants_1.OrderConfig.TOP, sync: constants_1.SyncConfig.ASYNC };
exports.URL = 'https://hcaptcha.com/1/api.js?render=';
//# sourceMappingURL=constants.js.map